"use client";

import { AnimateOnScroll } from "@/components/shared/AnimateOnScroll";
import { AppStoreBadges } from "@/components/shared/AppStoreBadges";

export function FinalCTA() {
  return (
    <section className="relative overflow-hidden py-20 sm:py-28">
      {/* Gradient background — dramatic dark blue */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-ink via-[hsl(222_47%_15%)] to-[hsl(217_50%_20%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(217_91%_60%/0.15),transparent_60%)]" />

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
        <AnimateOnScroll direction="scale">
          <h2 className="text-4xl font-bold tracking-tight text-ink-foreground sm:text-5xl lg:text-6xl">
            Start optimizing your
            <br />
            <span className="bg-gradient-to-r from-primary-glow to-[hsl(217_80%_80%)] bg-clip-text text-transparent">
              brain today
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-xl text-ink-foreground/75 sm:text-2xl">
            Take the quiz and get your first step today. Free to download, with
            a 7-day free trial of the Guided plan.
          </p>
          <div className="mt-8">
            <AppStoreBadges placement="cta" size="lg" />
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
